import { createAction, props } from '@ngrx/store';
import { AuthResponse, FirebaseResponse } from '../../core/models/auth';


export const login = createAction(
    '[Auth] Login',
    props<{ email: string; password: string }>()
);

export const loginSuccess = createAction(
    '[Auth] Login Success',
    props<{ authResponse: AuthResponse }>()
);

export const loginFailure = createAction(
    '[Auth] Login Failure',
    props<{ error: any }>()
);

// forse meglio unificare FIXME: SANTIAGO

export const loginFirebase = createAction(
    '[Auth] Login Firebase',
    props<{ email: string; password: string }>()
);

export const loginSuccessFirebase = createAction(
    '[Auth] Login Success Firebase',
    props<{ firebaseResponse: FirebaseResponse }>()
);

export const loginFailureFirebase = createAction(
    '[Auth] Login Failure Firebase',
    props<{ error: any }>()
);

export const logout = createAction('[Auth] Logout');